import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Card,
  Alert,
} from "react-bootstrap";
import BotonMenu from "./BotonMenu";
import Banners from "./Banners";

// Función para formatear números como moneda (ej. $1,234.56)
const formatCurrency = (value) => {
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN", // Puedes cambiarlo a tu moneda local, ej. 'USD'
  }).format(value);
};

const CreditSimulator = () => {
  // --- ESTADO PARA LOS INPUTS DEL FORMULARIO ---
  const [monto, setMonto] = useState("30000");
  const [plazo, setPlazo] = useState("10"); // en años
  const [tasaInteresAnual, setTasaInteresAnual] = useState("11.75");
  const [seguroMensual, setSeguroMensual] = useState(""); // Campo para el seguro y otros
  const navigate = useNavigate();
  // Estado para guardar la opción seleccionada
  const [tipoPrestamo, setTipoPrestamo] = useState('');  
  //const [divStyle, setDivStyle] = useState();

  // --- ESTADO PARA LOS RESULTADOS CALCULADOS ---
  const [amortizationData, setAmortizationData] = useState([]);
  const [summary, setSummary] = useState(null);

      // Función que realiza el cálculo de la prima del seguro
  const calcularSeguro = (tipo, valorMonto) => {
      const montoNumerico = parseFloat(valorMonto);
      let seguro = parseFloat(seguroMensual);

      // No calcular si el monto no es válido o no hay un tipo de préstamo seleccionado
      if (isNaN(montoNumerico) || montoNumerico <= 0 || !tipo) {
          setSeguroMensual("");
          //console.info(tipo)
          //console.info("set null?");
          return;
      }
      //console.info("sigueee..");
/*       let tasaInteresAnual;
      if (tipo === "personal") {
          tasaInteresAnual = 0.015; // 1.5%
      } else if (tipo === "automotriz") {
          tasaInteresAnual = 0.0125; // 1.25%
      } else {
          // Caso por defecto para hipotecario (0.5%)
          tasaInteresAnual = 0.005; // 0.5%
      } */

        if (tipoPrestamo === "personal") {
          //setSeguroMensual(0.015);
          seguro = 0.015; //1.5 % 0.015
      } else if (tipoPrestamo === "automotriz") {
          //setSeguroMensual(0.0125);
          seguro = 0.0125; //1.25 % 0.0125
      } else {
          // Caso por defecto para hipotecario (0.5%)
          seguro = 0.005;
      }           
      
      const resultado = (seguro * montoNumerico) / 12;
      setSeguroMensual(resultado.toFixed(2));
      //setSeguroMensual(seguro);
  };

    // Usamos useEffect para que el cálculo se ejecute cada vez que el "monto" o el "tipoPrestamo" cambien.
    useEffect(() => {
        calcularSeguro(tipoPrestamo, monto);
    }, [tipoPrestamo, monto]);  

  const handleCalculate = (e) => {
    e.preventDefault(); // Evita que el formulario recargue la página

    // console.info(divStyle);

    // --- VALIDACIÓN Y CONVERSIÓN DE DATOS ---
    const principal = parseFloat(monto);
    const anios = parseInt(plazo, 10);
    const tasaAnual = parseFloat(tasaInteresAnual);
    let seguro = parseFloat(seguroMensual);

/*         if (tipoPrestamo === "personal") {
            setSeguroMensual(0.015);
            seguro = 0.015; //1.5 %
        } else if (tipoPrestamo === "automotriz") {
            setSeguroMensual(0.0125);
            seguro = 0.0125; //1.25 %
        } else {
            // Caso por defecto para hipotecario (0.5%)
            setSeguroMensual(0.005);
            seguro = 5;
        } */
            

    if (
      isNaN(principal) ||
      isNaN(anios) ||
      isNaN(tasaAnual) ||
      principal <= 0 ||
      anios <= 0 ||
      tasaAnual <= 0
    ) {
      alert("Por favor, introduce valores válidos en todos los campos.");
      return;
    }

    // --- CÁLCULOS FINANCIEROS ---
    const tasaInteresMensual = tasaAnual / 100 / 12;
    const numeroDeCuotas = anios * 12;

    // Fórmula para calcular la cuota mensual (solo capital e intereses)
    const cuotaCapitalInteres =
      (principal *
        (tasaInteresMensual *
          Math.pow(1 + tasaInteresMensual, numeroDeCuotas))) /
      (Math.pow(1 + tasaInteresMensual, numeroDeCuotas) - 1);

    const cuotaTotalMensual = cuotaCapitalInteres + (seguro || 0);

    // --- GENERACIÓN DE LA TABLA DE AMORTIZACIÓN ---
    let saldoRestante = principal;
    const tabla = [];
    let totalInteresesPagados = 0;

    for (let i = 1; i <= numeroDeCuotas; i++) {
      const interesDelPeriodo = saldoRestante * tasaInteresMensual;
      const amortizacionDelPeriodo = cuotaCapitalInteres - interesDelPeriodo;
      const saldoFinal = saldoRestante - amortizacionDelPeriodo;

      tabla.push({
        periodo: i,
        saldoInicial: saldoRestante,
        pago: cuotaTotalMensual,
        intereses: interesDelPeriodo,
        seguroYOtros: seguro || 0,
        amortizacion: amortizacionDelPeriodo,
        saldoFinal: saldoFinal,
      });

      saldoRestante = saldoFinal;
      totalInteresesPagados += interesDelPeriodo;
    }

    // --- ACTUALIZACIÓN DEL ESTADO ---
    setAmortizationData(tabla);
    setSummary({
      numeroCuotas: numeroDeCuotas,
      cuotaAPagar: cuotaTotalMensual,
      totalIngresosAPagar: cuotaTotalMensual * numeroDeCuotas,
      totalSeguros: (seguro || 0) * numeroDeCuotas,
      totalIntereses: totalInteresesPagados,
      montoSolicitado: principal,
    });
  };

  return (
    <Container className="my-5">
      <Row className="justify-content-md-center">
        <Banners BannerShow={1} Act={1}></Banners>
        <Col md={10} lg={8}>
          <BotonMenu></BotonMenu>
          <div style={styles.simulatorBody}>
            {/* --- PANEL IZQUIERDO: FORMULARIO --- */}
            <div style={styles.panel}>
              <form onSubmit={handleCalculate}>
                <Form.Group className="mb-3" controlId="formTipo">
                    <Form.Label>Tipo de Préstamo</Form.Label>
                    <Form.Select 
                        required
                        value={tipoPrestamo} 
                        onChange={(e) => setTipoPrestamo(e.target.value)}
                    >
                        <option value="">Selecciona una opción</option>
                        <option value="automotriz">Automotriz</option>
                        <option value="personal">Personal</option>
                        <option value="hipotecario">Hipotecario</option>
                    </Form.Select>
                </Form.Group>                
                <div style={styles.formGroup}>
                  <label htmlFor="monto">Monto</label>
                  <input
                    type="number"
                    id="monto"
                    value={monto}
                    onChange={(e) => setMonto(e.target.value)}
                    style={styles.input}
                    placeholder="Ej: 30000"
                  />
                </div>
                <div style={styles.formGroup}>
                  <label htmlFor="plazo">Plazo (en años)</label>
                  <input
                    type="number"
                    id="plazo"
                    value={plazo}
                    onChange={(e) => setPlazo(e.target.value)}
                    style={styles.input}
                    placeholder="Ej: 10"
                  />
                </div>
                <div style={styles.formGroup}>
                  <label htmlFor="tasa">Tasa interés anual (%)</label>
                  <input
                    type="number"
                    step="0.01"
                    id="tasa"
                    value={tasaInteresAnual}
                    onChange={(e) => setTasaInteresAnual(e.target.value)}
                    style={styles.input}
                    placeholder="Ej: 11.75"
                  />
                </div>
                <div style={styles.formGroup}>
                  <label htmlFor="seguro">Seguro y otros (mensual)</label>
                  <input
                    type="number"
                    step="0.01"
                    id="seguro"
                    value={seguroMensual}
                    onChange={(e) => setSeguroMensual(e.target.value)}
                    style={styles.input}
                    placeholder="Ej: 14.00"
                  />
                </div>
                <div style={styles.formGroup}>
                  <label>Forma de pago</label>
                  {/* <input type="text" value="Mensual" style={styles.input} readOnly /> */}
                  <p style={styles.input}>Mensual</p>
                </div>

                <button type="submit" style={styles.button}>
                  Calcular
                </button>
              </form>
              <Row>
                 <span> *Cálculos son únicamente de referencia estos podrán variar al momento que la Institución financiera les de las condiciones del crédito </span>
              </Row>
            </div>

            {/* --- PANEL DERECHO: RESUMEN DE RESULTADOS --- */}

            {summary && (
              <>
                <div style={styles.panel}>
                  <div style={styles.summaryItem}>
                    <span>Número cuotas</span>
                    <strong>{summary.numeroCuotas}</strong>
                  </div>
                  <div style={styles.summaryItem}>
                    <span>Cuota a pagar</span>
                    <strong>{formatCurrency(summary.cuotaAPagar)}</strong>
                  </div>
                  <hr style={styles.hr} />
                  <div style={styles.summaryItem}>
                    <span>Total de ingresos a pagar</span>
                    <strong>
                      {formatCurrency(summary.totalIngresosAPagar)}
                    </strong>
                  </div>
                  <div style={styles.summaryItem}>
                    <span>Total de seguros</span>
                    <strong>{formatCurrency(summary.totalSeguros)}</strong>
                  </div>
                  <div style={styles.summaryItem}>
                    <span>Total de intereses</span>
                    <strong>{formatCurrency(summary.totalIntereses)}</strong>
                  </div>
                </div>
              </>
            )}
          </div>
          {/*         <div className='row'>
            <Button variant="link" onClick={() => navigate('/calculadoras-financieras')} className="ms-2">
                Ir a Calculadoras
            </Button>  
        </div>   */}

          {/* --- SECCIÓN INFERIOR: TABLA DE AMORTIZACIÓN --- */}
          {amortizationData.length > 0 && (
            <div style={styles.tableContainer}>
              <h2 style={styles.title}>Tabla de amortización</h2>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Período</th>
                    <th style={styles.th}>Saldo inicial</th>
                    <th style={styles.th}>Pago</th>
                    <th style={styles.th}>Intereses</th>
                    <th style={styles.th}>Seguro y otros</th>
                    <th style={styles.th}>Amortización</th>
                    <th style={styles.th}>Saldo final</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Fila 0 para mostrar el monto inicial */}
                  <tr>
                    <td style={styles.tdCenter}>0</td>
                    <td style={styles.td}></td>
                    <td style={styles.td}></td>
                    <td style={styles.td}></td>
                    <td style={styles.td}></td>
                    <td style={styles.td}></td>
                    <td style={styles.tdRightBold}>
                      {formatCurrency(summary.montoSolicitado)}
                    </td>
                  </tr>
                  {amortizationData.map((row) => (
                    <tr key={row.periodo}>
                      <td style={styles.tdCenter}>{row.periodo}</td>
                      <td style={styles.tdRight}>
                        {formatCurrency(row.saldoInicial)}
                      </td>
                      <td style={styles.tdRight}>{formatCurrency(row.pago)}</td>
                      <td style={styles.tdRight}>
                        {formatCurrency(row.intereses)}
                      </td>
                      <td style={styles.tdRight}>
                        {formatCurrency(row.seguroYOtros)}
                      </td>
                      <td style={styles.tdRight}>
                        {formatCurrency(row.amortizacion)}
                      </td>
                      <td style={styles.tdRightBold}>
                        {formatCurrency(row.saldoFinal)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <Row>
            <Banners BannerShow={2} Act={1}></Banners>
          </Row>
        </Col>
        <Banners BannerShow={1} Act={1}></Banners>
      </Row>
    </Container>
  );
};

// --- ESTILOS CSS-in-JS ---
const styles = {
  container: {
    /*    backgroundColor: '#4a90e2', */
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    color: "#333",
  },
  simulatorBody: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    marginBottom: "20px",
  },
  panel: {
    backgroundColor: "#f0f0f0",
    padding: "20px",
    borderRadius: "8px",
    flex: 1,
    minWidth: "300px",
  },
  formGroup: {
    marginBottom: "15px",
  },
  input: {
    width: "100%",
    padding: "8px",
    boxSizing: "border-box",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
  button: {
    padding: "10px 20px",
    border: "none",
    borderRadius: "4px",
    backgroundColor: "#d0d0d0",
    cursor: "pointer",
    fontWeight: "bold",
  },
  summaryItem: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
    fontSize: "1.1em",
  },
  hr: {
    border: "none",
    borderTop: "1px solid #ccc",
    margin: "15px 0",
  },
  tableContainer: {
    backgroundColor: "#ffffff",
    padding: "20px",
    borderRadius: "8px",
    overflowX: "auto", // Para que la tabla sea responsive en pantallas pequeñas
  },
  title: {
    color: "#0056b3",
    textAlign: "center",
    marginBottom: "20px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    backgroundColor: "#e0f7fa",
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
  },
  td: {
    padding: "8px",
    border: "1px solid #ddd",
  },
  tdRight: {
    padding: "8px",
    border: "1px solid #ddd",
    textAlign: "right",
  },
  tdRightBold: {
    padding: "8px",
    border: "1px solid #ddd",
    textAlign: "right",
    fontWeight: "bold",
  },
  tdCenter: {
    padding: "8px",
    border: "1px solid #ddd",
    textAlign: "center",
  },
};

export default CreditSimulator;
